class UspIconsSlider extends HTMLElement {
  connectedCallback() {
    const carousel = this.querySelector('.icon-mobile-carousel');
    const prev = this.querySelector('.carousel-arrow.prev');
    const next = this.querySelector('.carousel-arrow.next');

    const getScrollAmount = () => {
      const scrollItem = carousel?.querySelector('.grid__item');
      return scrollItem?.offsetWidth || 0;
    };

    const updateButtons = () => {
      if (!carousel || !prev || !next) return;

      prev.disabled = carousel.scrollLeft <= 0;

      const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
      next.disabled = carousel.scrollLeft >= maxScrollLeft - 1;
    };

    const scrollCarousel = (direction) => {
      const amount = getScrollAmount();
      if (amount === 0) return;
      carousel.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    if (carousel && prev && next) {
      prev.addEventListener('click', () => scrollCarousel(-1));
      next.addEventListener('click', () => scrollCarousel(1));

      carousel.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);

      requestAnimationFrame(updateButtons);
    }
  }
}

customElements.define('usp-icons-slider', UspIconsSlider);
